{
  "title": "Management",
  "title_Agrifirm": "Management",
  "title_Agravis": "Avidata Management",
  "home": "Home",
  "app": {
    "no_results_title": "No results",
    "no_results_description": "No results were found.",
    "customer": {
      "module": "Customer Management",
      "search": {
        "placeholder": "Select a customer"
      },
      "customer": "Customers",
      "add-customer": "Add Customer",
      "edit-customer": "Change Customer information",
      "navigation": {
        "details": "Details",
        "locations": "Locations"
      },
      "detail": {
        "add_location": "Add location to customer: ",
        "edit_location": "Change location of customer: ",
        "title_general": "General information",
        "title_address": "Address information",
        "title_contact": "Contact information",
        "id": "ID",
        "name": "Name",
        "location_type": "Location Type",
        "email_address": "Email Address",
        "street": "Street",
        "postal_code": "Postal Code",
        "house_number": "House Number",
        "house_number_addition": "House Number Addition",
        "city": "City",
        "country": "Country",
        "phone_number": "Phone Number",
        "mobile_number": "Mobile Number"
      },
      "confirmmsg": {
        "delete_item_location": "Do you wish to delete this location?",
        "delete_item_customer": "Do you wish to delete this customer?"
      }
    },
    "contactperson": {
      "module": "Contactperson Management",
      "search": {
        "placeholder": "Select a contactperson"
      },
      "contactperson": "Contactperson",
      "contactpersons": "Contactpersons",
      "add-contactperson": "Add contactperson",
      "edit-contactperson": "Change information of contactperson",
      "navigation": {
        "details": "Details",
        "authorizations": "Authorizations",
        "relations": "Customer Relations"
      },
      "has_relation_label": "relation",
      "all_locations_relation_label": "All locations have a relation with this contactperson",
      "detail": {
        "add_location": "Add location of contactperson ",
        "edit_location": "Edit location of contactperson ",
        "title_general": "General information",
        "title_address": "Address information",
        "title_contact": "Contact information",
        "id": "ID",
        "first_name": "First name",
        "last_name": "Last name",
        "location_type": "Location Type",
        "email_address": "Email Address",
        "street": "Street",
        "postal_code": "Postal Code",
        "house_number": "House Number",
        "house_number_addition": "House Number Addition",
        "city": "City",
        "country": "Country",
        "phone_number": "Phone Number",
        "mobile_number": "Mobile Number"
      },
      "relations": {
        "location_detail_page_title": "Submit relations for contactperson",
        "title_search_customer": "Select the customer with whom you want to submit a relation",
        "title_select_location": "Select the location of this customer where you want to submit a relation"
      },
      "confirmmsg": {
        "delete_item_location": "Do you wish to delete this location?",
        "delete_item_contactperson": "Do you wish to delete this contactperson?"
      },
      "authorization": {
        "add_applicationgroup": "Add Application Group",
        "contactperson_employee_not_found": "The contactperson could not be found. It's possible this is caused by the fact that the emailaddress is used multiple times."
      }
    },
    "employee": {
      "module": "Employee Management",
      "edit-employee": "Change information of employee",
      "search": {
        "placeholder": "Select employee"
      },
      "employees": "Employees",
      "navigation": {
        "details": "Details",
        "relations": "Employee Relationships"
      },
      "detail": {
        "title_general": "General information",
        "title_contact": "Contact information",
        "user_name": "User name",
        "first_name": "First name",
        "last_name": "Last name",
        "email": "Email Address",
        "mobile_number": "Mobile Number",
        "status": "Status",
        "active": "Active",
        "inactive": "Inactive"
      },
      "relations": {
        "add_relation": "Add employee relationship",
        "back_to_relations": "Back to relations",
        "all_locations_relation_label": "Customer-level authorization",
        "customer_relation": "Customer-level authorization",
        "shipto_relation": "location authorization(s)",
        "has_relation_label": "relation",
        "no_relation": "No relation",
        "no_relations_found": "No employee relationships found for this employee yet.",
        "relationship_type": "Relationship type",
        "select_customer": "Select customer",
        "title_search_customer": "Select the customer with whom you want to submit a relation",
        "title_select_location": "Select the location of this customer where you want to submit a relation"
      }
    },
    "errormsg": {
      "not_found": "The data could not be found.",
      "not_loaded": "The data could not be loaded.",
      "mandatory_form_field": "This field is mandatory.",
      "email_pattern": "Does not comply to email format."
    },
    "successmsg": {
      "upsert_success": "Successfully saved.",
      "delete_success": "The item has been deleted."
    },
    "countries": {
      "NL": "Netherlands",
      "BE": "Belgium",
      "GB": "Great Brittain",
      "FR": "France",
      "PL": "Poland",
      "UA": "Ukraine",
      "ES": "Spain",
      "JO": "Jordan",
      "HU": "Hungary",
      "NG": "Nigeria",
      "FI": "Finland",
      "CN": "China",
      "JM": "Jamaica",
      "TZ": "Tanzania",
      "KE": "Kenya",
      "UG": "Uganda",
      "DE": "Germany"
    }
  }
}
